import { gql } from '@apollo/client';

export const GET_ALL_ZIPCODE_OPTIONS = gql`
  query GetAllZipcodeOptions {
    getAllZipcodeOptions {
      zipcode
      city
      state
    }
  }
`;

export interface ZipcodeOption {
  zipcode: string;
  city: string;
  state: string;
}

export interface GetAllZipcodeOptionsResponse {
  getAllZipcodeOptions: ZipcodeOption[];
}
